var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.873,
    height: 57.873,
    viewBox: "0 0 57.873 57.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-930.025 841.435) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1266.137,93.408a4.365,4.365,0,0,0-3.181,1.278,5.34,5.34,0,0,0-.5.572V82.333a3.768,3.768,0,0,0-7.536,0v9.386a7.215,7.215,0,0,1-8.386-.068,3.758,3.758,0,0,1-6.077.729,3.772,3.772,0,0,0-3.768,3.768v16.5a15.922,15.922,0,0,0,31.844,0V95.6A2.23,2.23,0,0,0,1266.137,93.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1281.489,126.339a2.309,2.309,0,1,1,4.619,0v9.712a2.309,2.309,0,1,1-4.619,0v-9.712Z",
    transform: "translate(-31.187 -31.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1261.489,128.739a2.309,2.309,0,0,1,4.619,0v8.983a2.309,2.309,0,1,1-4.619,0v-8.983Z",
    transform: "translate(-17.264 -33.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1241.489,131.139a2.309,2.309,0,0,1,4.619,0v8.253a2.309,2.309,0,1,1-4.619,0Z",
    transform: "translate(-3.342 -34.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1270.416,115.983a14.464,14.464,0,0,1-28.927,0v-5.271a7.342,7.342,0,0,1,8.386.8,3.755,3.755,0,0,1,6.077,0,3.772,3.772,0,0,0,3.768-3.768V85.673a2.309,2.309,0,1,1,4.619,0v17.062a.713.713,0,0,0,.013.126c-.008.153-.013.305-.013.459v7.21a14.444,14.444,0,0,0-10.9,5.9.729.729,0,1,0,1.178.859,12.979,12.979,0,0,1,10.452-5.319.73.73,0,0,0,.729-.729V103.32a6.125,6.125,0,0,1,1.522-4.253,2.877,2.877,0,0,1,2.134-.86c.359.006.962.11.962.737V109.4a.724.724,0,0,0,.034.21l-.034.011Z",
    transform: "translate(-3.342 -3.34)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.b7e202abced91c65f92050f8a6fbcc3d.svg";
export { ForwardRef as ReactComponent };